import * as Yup from "yup";
import * as cardValidator from 'card-validator';

export const AddCreditCardSchema = Yup.object().shape({
  card_type: Yup.string().required("Card type is required."),
  card_name: Yup.string().required("Name on card is required."),
  card_number: Yup.string().required("Card number is required.").test({
    name: 'card_number',
    message: "Invalid credit card number",
    test: (value) => {
      return cardValidator.number(value).isValid;
    }
  }).when('card_type', {
    is: 'VISA', //mc amex
    then: Yup.string().test({
      name: 'card_number',
      message: "Invalid VISA credit card number",
      test: (value) => {
        let validate = cardValidator.number(value);
        return value && validate.card && validate.card.type === 'visa';
      }
    })
  }).when('card_type', {
    is: 'MC',
    then: Yup.string().test({
      name: 'card_number',
      message: "Invalid MasterCard card number",
      test: (value) => {
        let validate = cardValidator.number(value);
        return value && validate.card && validate.card.type === 'mastercard';
      }
    })
  }).when('card_type', {
    is: 'AMEX', //mc amex
    then: Yup.string().test({
      name: 'card_number',
      message: "Invalid American Express card number",
      test: function(value){
        let validate = cardValidator.number(value);
        return value && validate.card && validate.card.type === 'american-express';
      }
    })
  }),
  card_validation_code: Yup.string().required("Card cvv is required."),
  card_month: Yup.string().required("Expiration month is required."),
  card_year: Yup.string().required("Expiration year is required."),
});
export const EditCreditCardSchema = Yup.object().shape({
  card_name: Yup.string().required("Name on card is required."),
  card_month: Yup.string().required("Expiration month is required."),
  card_year: Yup.string().required("Expiration year is required."),
});

/**
 * @return {number}
 */
function checkRoutingNumber2EC(r) {
  let s = 0, m = 0, n = [3, 7, 1];
  for (let i = 0; i < r.length; i++) {
    s += parseInt(r.charAt(i)) * n[m];
    m = (++m < 3 ? m : 0);
  }
  return s
}

/**
 * @return {boolean}
 */
function checkRoutingNumber1EC(r) {
  let s = '';
  for (let i = 0; i < r.length; i++) {
    if (!Number.isNaN(r.charAt(i)))
      s += r.charAt(i)
  }
  if (s.length !== 9)
    return false;
  const c = checkRoutingNumber2EC(s);
  return !!(c && c % 10 === 0);
}

const accountNumberRegExpr = "^[0-9 -]+$";

/**
 * @return {boolean}
 */
function checkAccountNumberEC(value) {
  let re = new RegExp(accountNumberRegExpr);
  if(re.test(value)){
    let valueStringsRemoved = value.replace(/ /g, "");
    if (valueStringsRemoved.length < 5 || valueStringsRemoved.length > 17)
      return false;
  }
  return true;
}



export const AddCheckSchema = Yup.object().shape({
  type: Yup.string().required("Account type is required."),
  name: Yup.string().required("Name on Account is required."),
  routing_number: Yup.string().required("Routing number is required.").test({
    name: 'routing_number',
    message: "Invalid routing number.",
    test: (value) => {
      if(typeof value === "undefined"){
        return false; 
      }
      if(value === null){
        return false;
      }
      if(value.length <  1){
        return false;
      }
      return checkRoutingNumber1EC(value); 
    }
  }),
  account_number: Yup.string().required("Account number is required.").test({
    name: 'routing_number',
    message: "Invalid account number.",
    test: (value) => {
      if(typeof value === "undefined"){
        return false;
      }
      if(value === null){
        return false;
      }
      if(value.length <  1){
        return false;
      }
      return checkAccountNumberEC(value); 
    }
  }),
});

export const EditCheckSchema = Yup.object().shape({
  name: Yup.string().required("Name is required."),
});

export const MakeDepositSchema = Yup.object().shape({
  amount_to_process: Yup.number("Amount is not a valid number.").required("Amount is required.").positive().min(1, "Amount must be 1 or greater than 1."),
});
